<template>
  <NSelect class="n-pixType" v-bind="attrs" :get-popup-container="node => node.parentNode" />
</template>

<script setup>
import {useBootstrap} from '@front/hooks';
import {computed, watch} from 'vue';

const props = defineProps({
  value: undefined,
});

const emit = defineEmits(['update:value']);

const { ENUMS } = useBootstrap();

const attrs = computed(() => ({
  options: ENUMS.value.PixType,
  label: 'pixType',
  // ...useAttrs(),
  value: props.value,
  'onUpdate:value': v => emit('update:value', v),
}));

watch(
  () => {},
  to => {
    if (props.value && !to.find(o => o.value === props.value)) {
      emit('update:value', null);
    }
  },
);
</script>

<script>
export default {
  name: 'NPixType',
};
</script>
